import React, { forwardRef, useLayoutEffect } from 'react';
import { AdHocCombobox } from './AdHocFiltersCombobox.js';

const GROUP_BY_WIP = { key: "", value: "", operator: "groupBy", condition: "" };
const AdHocFiltersAlwaysWipCombobox = forwardRef(function AdHocFiltersAlwaysWipCombobox2({ controller, onInputClick, isGroupBy }, parentRef) {
  const { wip } = controller.useState();
  const activeWip = isGroupBy ? GROUP_BY_WIP : wip;
  useLayoutEffect(() => {
    if (!activeWip) {
      controller.addWip();
    }
  }, [activeWip]);
  return /* @__PURE__ */ React.createElement(
    AdHocCombobox,
    {
      controller,
      filter: activeWip,
      isAlwaysWip: true,
      isGroupBy,
      ref: parentRef,
      onInputClick
    }
  );
});

export { AdHocFiltersAlwaysWipCombobox };
//# sourceMappingURL=AdHocFiltersAlwaysWipCombobox.js.map
